var _title, _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDeals = function SvgDeals(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "collection icon")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.07,17.88 C8.17666667,17.88 8.25166667,17.8566667 8.295,17.81 C8.33833333,17.7633333 8.36,17.69 8.36,17.59 L8.36,17.59 L8.36,16.83 C8.97333333,16.7433333 9.45833333,16.525 9.815,16.175 C10.1716667,15.825 10.35,15.36 10.35,14.78 C10.35,14.36 10.26,14.0266667 10.08,13.78 C9.9,13.5333333 9.69333333,13.3533333 9.46,13.24 C9.22666667,13.1266667 8.93,13.0166667 8.57,12.91 C8.49,12.87 8.35666667,12.83 8.17,12.79 C7.73,12.67 7.375,12.5466667 7.105,12.42 C6.835,12.2933333 6.7,12.1266667 6.7,11.92 C6.7,11.72 6.79333333,11.5733333 6.98,11.48 C7.16666667,11.3866667 7.36666667,11.34 7.58,11.34 C7.74,11.34 7.89833333,11.3633333 8.055,11.41 C8.21166667,11.4566667 8.33666667,11.5233333 8.43,11.61 C8.53,11.7033333 8.6,11.8033333 8.64,11.91 C8.64666667,11.9233333 8.65833333,11.9533333 8.675,12 C8.69166667,12.0466667 8.71666667,12.0883333 8.75,12.125 C8.78333333,12.1616667 8.83666667,12.18 8.91,12.18 L8.91,12.18 L9.89,12.18 C10.01,12.18 10.0883333,12.1633333 10.125,12.13 C10.1616667,12.0966667 10.18,12.02 10.18,11.9 C10.18,11.4133333 10.0083333,11.0166667 9.665,10.71 C9.32166667,10.4033333 8.88666667,10.1966667 8.36,10.09 L8.36,10.09 L8.36,9.29 C8.36,9.19 8.33833333,9.11666667 8.295,9.07 C8.25166667,9.02333333 8.17666667,9 8.07,9 L8.07,9 L7.29,9 C7.18333333,9 7.10833333,9.02333333 7.065,9.07 C7.02166667,9.11666667 7,9.19 7,9.29 L7,9.29 L7,10.06 C6.44,10.16 5.98166667,10.3733333 5.625,10.7 C5.26833333,11.0266667 5.09,11.4566667 5.09,11.99 C5.09,12.39 5.17666667,12.7166667 5.35,12.97 C5.52333333,13.2233333 5.745,13.4233333 6.015,13.57 C6.285,13.7166667 6.62333333,13.8533333 7.03,13.98 C7.13666667,14.0133333 7.35666667,14.07 7.69,14.15 C8.06333333,14.2366667 8.33666667,14.3233333 8.51,14.41 C8.68333333,14.4966667 8.77,14.6333333 8.77,14.82 C8.77,15.08 8.68333333,15.2583333 8.51,15.355 C8.33666667,15.4516667 8.09666667,15.5 7.79,15.5 C7.58333333,15.5 7.39166667,15.4733333 7.215,15.42 C7.03833333,15.3666667 6.90333333,15.2833333 6.81,15.17 C6.69666667,15.0366667 6.63333333,14.9 6.62,14.76 C6.61333333,14.64 6.58333333,14.5633333 6.53,14.53 C6.47666667,14.4966667 6.38666667,14.48 6.26,14.48 L6.26,14.48 L5.29,14.48 C5.17666667,14.48 5.1,14.4983333 5.06,14.535 C5.02,14.5716667 5,14.6466667 5,14.76 C5,15.3 5.19166667,15.7466667 5.575,16.1 C5.95833333,16.4533333 6.43333333,16.69 7,16.81 L7,16.81 L7,17.59 C7,17.69 7.02166667,17.7633333 7.065,17.81 C7.10833333,17.8566667 7.18333333,17.88 7.29,17.88 L7.29,17.88 L8.07,17.88 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "collection-icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    x: 0,
    y: 6,
    width: 16,
    height: 15
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-31",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    points: "3 5.64705882 3 3 19 3 19 18 16.4736842 18"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-31",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    points: "6 2.64705882 6 0 22 0 22 15 19.4736842 15"
  }), /*#__PURE__*/React.createElement("g", {
    id: "$",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#333333",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDeals, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/deals.610da236.svg";
export { ForwardRef as ReactComponent };